import "./AboutPage.scss";

function AboutPage() {
  return (
    <div className="about">
      <div className="about__wrapper">
        <h2 className="about__heading">About</h2>
        <p className="about__content">
          Welcome to UnGriefMe, a compassionate space dedicated to supporting
          those who are navigating the journey of grief. I believe in the
          healing power of shared experiences. The Griefitti Wall is a place
          where a grieving individual can share their story, but only when
          logged in. It often helps to know you're not alone in difficult times.
          soothing music, and reliable resources. My mission is to provide a
          safe and comforting space where you can find solace, understanding,
          and hope.
        </p>

        <h2 className="about__heading">My Story</h2>
        <p className="about__content">
          Born out of a personal journey through loss, UnGriefMe was created to
          offer a beacon of light in the darkest of times. I understand the
          profound loneliness that grief can bring. It is a universal
          experience, one that touches every heart at different moments in life,
          regardless of where we come from.
        </p>

        <h2 className="about__heading">What UnGriefMe Offers</h2>
        <ul>
          <li className="about__item-title">
            Share Your Story:
            <p>
              The power of sharing stories of grief lies in fostering
              connection, understanding, and healing by validating emotions,
              offering solace, and creating a supportive community for those
              navigating their loss.
            </p>
          </li>

          <li className="about__item-title">
            Comprehensive Resources:
            <p>
              Explore an extensive library of articles, guides, and tools to
              help you understand and navigate your grief.
            </p>
          </li>

          <li className="about__item-title">
            Healing Music:
            <p>
              Dive into our curated collection of music designed to soothe the
              soul and provide comfort during difficult times.
            </p>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default AboutPage;
